import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import FontFileField from '../../../../../form-fields/super-cut/font-file'

const FontFile = styled(FontFileField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoFontFileField = ({ field }: Props) => {
    return (
        <FontFile
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoFontFileField
